import React, { useState, useEffect } from 'react';

const ConsoleTest = () => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    // Override console.log to capture logs
    const originalLog = console.log;
    const originalError = console.error;
    
    console.log = (...args) => {
      setLogs(prev => [...prev, { type: 'log', message: args.join(' '), timestamp: new Date().toLocaleTimeString() }]);
      originalLog(...args);
    };
    
    console.error = (...args) => {
      setLogs(prev => [...prev, { type: 'error', message: args.join(' '), timestamp: new Date().toLocaleTimeString() }]);
      originalError(...args);
    };

    // Test API call
    fetch('http://localhost:5000/gold')
      .then(response => response.json())
      .then(data => {
        console.log('API Test Success:', data);
      })
      .catch(error => {
        console.error('API Test Error:', error);
      });

    return () => {
      console.log = originalLog;
      console.error = originalError;
    };
  }, []);

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Console Test</h1>
      <div className="space-y-2">
        {logs.map((log, index) => (
          <div key={index} className={`p-2 rounded ${log.type === 'error' ? 'bg-red-100' : 'bg-blue-100'}`}>
            <span className="text-sm text-gray-500">{log.timestamp}</span>
            <span className={`ml-2 ${log.type === 'error' ? 'text-red-600' : 'text-blue-600'}`}>
              [{log.type.toUpperCase()}]
            </span>
            <span className="ml-2">{log.message}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConsoleTest;
